import { FormattedMessage } from 'react-intl';
import { config, getAssetUrl, Provider } from '../../../../utils/config';
import Button from '../../../atoms/Button';
import { EmbeddedAuthBaseProps } from '../../../organisms/EmbeddedAuth';
import './style.scss';

type ThirdPartySignInProps = EmbeddedAuthBaseProps & { providers: Provider[]; testIdPrefix: string };

const ThirdPartySignIn = ({ isEmbeddedAuth, providers, testIdPrefix }: ThirdPartySignInProps) => (
  <div className="form__row auth-form__row">
    {providers.map(({ key, color }) => (
      <div className="form__field-container" key={key}>
        <Button
          type="button"
          className="provider"
          onClick={() => {
            if (isEmbeddedAuth) {
              const urlParams = new URLSearchParams(window.location.search);
              window.parent.postMessage(
                {
                  type: 'redirect',
                  redirect: {
                    method: 'GET',
                    url: `${config.apiHost}/auth/external/${key}?${new URLSearchParams({
                      redirect: urlParams.get('parentUrl') ?? document.referrer,
                    }).toString()}`,
                  },
                },
                '*'
              );
            } else {
              const redirectUrl = new URL(window.location.href);
              redirectUrl.searchParams.set('coAuthenticate', 'true');
              redirectUrl.hash = '';
              window.location.href = `${config.apiHost}/auth/external/${key}?${new URLSearchParams({
                redirect: redirectUrl.toString(),
              }).toString()}`;
            }
          }}
          style={color ? { color, borderColor: color } : undefined}
          data-test-id={`${testIdPrefix}-${key}`}
        >
          <img src={getAssetUrl(`login/${key}.svg`)} alt={key} />
          <FormattedMessage id={`auth.continueWith${key.charAt(0).toUpperCase() + key.slice(1)}`} />
        </Button>
      </div>
    ))}
  </div>
);

export default ThirdPartySignIn;
